// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sZcS","left":"styles_left__17Zif","desktopActions":"styles_desktopActions__1jWAH","title":"styles_title__3SHCq"};